<template>
  <FloatingBox
    v-if="isVisible"
    ref="floating_cont"
    referenceElId="strategy_tab"
    :initialPlacement="coordinates.percentX !== -1 ? 'custom' : 'reference'"
    :initialReferenceOffset="{ x: 8, y: 8 }"
    :coordinates="coordinates"
    class="ffevcmpr anim-fade-in text-noselect"
    @update:coordinates="handleUpdateCoordinates"
  >
    <template #default="v">
      <div
        ref="inner"
        class="ffevcmpr_inner"
      >
        <div
          class="ffevcmpr_title f-center cursor-grab"
          @touchstart="e => v.flbox_methods.handleTouchstart(e)"
          @mousedown="e => v.flbox_methods.handleMousedown(e)"
        >
          <div
            class="mdi mdi-drag-vertical pa-1 text-normal-large mr-1 icon_btn csst cursor-grab clr-grey"
            @mouseenter="fl_positionTooltip"
          >
            <div
              class="csst_content clr-white text-nowrap"
              style="position: fixed; line-height: 1.2; max-width: 28rem"
              v-html="$t('tooltips.can_be_dragged_simple')"
            ></div>
          </div>
          <div class="ffevcmpr_title_text f-center">
            {{ $t('ev_comparison.ev_compare') }}
            <div
              class="mdi mdi-help-circle-outline text-medium ml-2 mr-auto my-auto clr-grey csst"
              @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'bottom' })"
            >
              <div
                class="csst_content clr-white csst_content_hoverable text-wrap"
                style="position: fixed; line-height: 1.2; max-width: 28rem"
                v-html="
                  $t('tooltips.ev_compare_explained_tra01', {
                    linkText: !$i18n.g1
                      ? `<div class='mdi mt-2 clr-primary d-flex'>
                        <i class='mdi mdi-youtube text-semi-large mr-1 line-height_1 my-auto'></i>
                          <a target='_blank' class='weight_700 link-underline my-auto' href='${links_url_links.ev_compare_tooltip.youtube_url}'>
                         </i> Watch video </a>
                        <i class='mdi mdi-book-information-variant text-semi-large mr-1 ml-2 line-height_1 my-auto'></i>
                         <a target='_blank' class='weight_700  link-underline my-auto' href='${links_url_links.ev_compare_tooltip.url}'>${links_url_links.ev_compare_tooltip.text}</a>
                         </div>`
                      : '',
                  })
                "
              ></div>
            </div>
          </div>
        </div>
        <EvComparePicker
          :instaApply="true"
          style="padding: 1rem"
        />
      </div>
    </template>
  </FloatingBox>
</template>

<script>
import EvComparePicker from '@/components/EvComparePicker/EvComparePicker'
import FloatingBox from '@/components/lib/FloatingBox'
import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'FloatingEvComparePicker',
  components: {
    EvComparePicker,
    FloatingBox,
  },
  mixins: [float_mix, links_mix],
  props: {
    isVisible: Boolean,
  },
  data() {
    return {
      pinned: false,
      coordinates: { percentX: -1, percentY: -1 },
    }
  },
  methods: {
    togglePinned() {
      this.pinned = !this.pinned
    },
    toggleKeepHistory() {
      this.gmfKeepHistory = !this.gmfKeepHistory
    },
    handleUpdateCoordinates({ percentX, percentY }) {
      this.coordinates = { percentX, percentY }
    },
  },
}
</script>

<style lang="scss" scoped>
.ffevcmpr {
  z-index: 8;
  --title-height: 2.5em;
  &_close {
    position: absolute;
    right: 0.5em;
  }
  &_inner {
    border-radius: 4px;
    background: var(--clr-black-1);
    box-shadow: 0px 0px 0px 1px var(--clr-black-2), var(--menu-shadow);
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
    max-height: var(--vh-5);
    overflow: auto;
  }
  &_title {
    overflow: hidden;
    border-bottom: solid 1px var(--clr-black-2);
    padding: 0 0.5em;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: var(--title-height);
    line-height: 1.1;
    z-index: 2;
    background: inherit;
    position: sticky;
    top: 0;
    &_text {
      width: 100%;
      font-size: 1rem;
      font-weight: 600;
      padding: 0 0.5em 0 0;
    }
    &_controls {
      display: flex;
      margin: 0 3rem 0 0.5em;
      &_item {
        // width: 4em;
        &:last-child {
          &:after {
            display: none;
          }
        }
        display: flex;
        align-items: center;
        justify-content: center;
        &:after {
          content: '';
          height: 100%;
          border-right: solid var(--clr-black-2) 1px;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
  }
}
</style>
